<template>
  <div class="main">
    <m-product-banner class-name="productBg" :title="banner.title" :desc="banner.desc"></m-product-banner>
    <div class="case">
      <div class="case-container w">
        <div class="m-title">
          <h2>单体药店仅用四个月，实现会员交易次数从27%提升至71%</h2>
        </div>
        <div class="case-background">
          <h3>项目背景</h3>
          <p>深圳一单体药店在长期经营中，发现会员经营数据非常不理想，会员忠诚度差，交易次数更微乎其微，直接导致的结果是销售额停滞不前，无法取得新的突破。</p>
        </div>
      </div>
    </div>

    <div class="process">
      <div class="process-container w">
        <div class="case-background">
          <h3>应用过程</h3>
          <p>为寻求突破，于2016年1月使用厚科ERP系统，在未使用前会员数不足8千,会员交易次数占比10.71%，会员交易金额占比12.17%。</p>
          <p>2017年8月，会员各项数据均提升，尤其会员数已达53000+，会员交易金额占比63.78%，开发会员数与会员交易金额已得到质的跨越。</p>
        </div>
        <ul class="chart chart1">
          <li>
            <h3>累计会员数</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic1.png" alt />
          </li>
          <li>
            <h3>会员客单价</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic2.png" alt />
          </li>
          <li>
            <h3>2016.02 会员交易次数占比</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic3.png" alt />
          </li>
          <li>
            <h3>2017.12 会员交易次数占比</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic4.png" alt />
          </li>
        </ul>

        <div class="case-background">
          <p>于2017年12月，会员数已达55000+，会员交易次数由期初的10.71%飞升至71%，会员交易金额占比由期初的12.17%飞升至77.82%， 会员交易金额由期初的2万元飞升至40.2万元，总交易金额由期初的17.1万飞升至51.6万。</p>
        </div>

        <ul class="chart chart2">
          <li>
            <h3>总交易金额</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic5.png" alt />
          </li>
          <li>
            <h3>会员交易金额</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic6.png" alt />
          </li>
          <li>
            <h3>2016.02 会员交易金额占比</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic7.png" alt />
          </li>
          <li>
            <h3>2017.12 会员交易金额占比</h3>
            <img class="chart-pic" src="~@/assets/imgs/chart-pic8.png" alt />
          </li>
        </ul>
      </div>
    </div>

    <div class="profit">
      <div class="profit-container w">
        <div class="case-background">
          <h3>项目收益</h3>
          <p>据负责人介绍，在其期间，借助厚科ERP系统的数据分析报表功能，让他们分析诊断出药店开发会员所存在的问题和会员客单价问题，并获取出会员消费变化趋势，从而对症下药，药店的会员才实现了稳定持续增长。而ERP系统的会员管理功能让他们发掘出沉睡会员，并活跃会员，精准营销会员，交易次数才得以提升。</p>
        </div>
        <img class="table-pic" src="~@/assets/imgs/chart-pic10.png" alt />
        <img class="table-pic" src="~@/assets/imgs/chart-pic11.png" alt />
        <img class="table-pic" src="~@/assets/imgs/chart-pic12.png" alt />
      </div>
    </div>
    <m-to-try class-name="c-apply" type="2"></m-to-try>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banner: {
        title: "经典案例",
        desc: ""
      }
    };
  }
};
</script>
<style lang='scss' scoped>
$color: #213d81;
/deep/ .c-link {
  background: $color;
}

/deep/ .c-apply {
  color: $color;
  background: url("../../assets/imgs/apply_bg.png") no-repeat top center / 100%
    100%;
}

/deep/ .productBg {
  background-image: url("../../assets/imgs/banner_service.png");
}

.case-background {
  h3 {
    margin-bottom: 48px;
    font-size: 48px;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.85);
    line-height: 66px;
  }
  p {
    margin-bottom: 16px;
    font-size: 32px;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.85);
    line-height: 50px;
    text-align: justify;
  }
}
.case {
  padding: 96px 48px;
  .m-title {
    margin-bottom: 156px;
  }
}
.process {
  background: #f1f2f5;
  padding: 48px 48px 96px;

  .chart {
    margin-top: 64px;
    li {
      margin-bottom: 64px;
      h3 {
        margin-bottom: 16px;
        font-size: 36px;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.85);
        line-height: 50px;
      }
      &:nth-child(1),
      &:nth-child(2) {
        .chart-pic {
          height: 256px;
        }
      }
      &:nth-child(3),
      &:nth-child(4) {
        .chart-pic {
          height: 346px;
        }
      }
    }
  }
  .chart2 {
    li {
      &:nth-child(1),
      &:nth-child(2) {
        .chart-pic {
          height: 200px;
        }
      }
    }
  }
}

.profit {
  padding: 48px;
  .table-pic {
    display: block;
    width: 100%;
    margin-top: 64px;
  }
}
</style>
